module.exports = __webpack_public_path__ + "img/logo.181af0f5.png";